/**
 * Dismissed flag for the Intercom launcher bubble.
 *
 * Same shape as `oldDashboardBannerState`: `localStorage` for persistence plus
 * a custom `window` event, because `storage` only fires in *other* tabs and the
 * close button and the header's Help button live in this one.
 */

const KEY = 'retraced:intercomLauncherDismissed';
const EVENT = 'retraced:intercomLauncherDismiss';

export function isIntercomLauncherDismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    // Private mode / storage disabled — show the launcher rather than crash.
    return false;
  }
}

export function setIntercomLauncherDismissed(dismissed: boolean): void {
  try {
    if (dismissed) localStorage.setItem(KEY, 'true');
    else localStorage.removeItem(KEY);
  } catch {
    // Ignore: the event below still syncs this tab for the session.
  }
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeIntercomLauncherDismiss(
  onChange: () => void,
): () => void {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
}
